import React from 'react'
import { usePageTitle } from '@btime/react-hooks'

import TemplateRecordPdfPrintButton from '../../../../containers/templateRecords/TemplateRecordPdfPrintButton'
import { usePermalinkNavigation } from '../../../../utils/routes/permalinkNavigation'
import PageHeaderPanel from '../../../../components/presentation/PageHeaderPanel'
import { useServiceOrder } from '../_load/ServiceOrderLoader'

const PageHeader = ({ templateId }) => {
  const serviceOrder = useServiceOrder()
  const navigate = usePermalinkNavigation()
  const getTitle = templateId => {
    if (templateId === 4) {
      return 'Orçamento de Viagem'
    }
    if (templateId === 5) {
      return 'Orçamento de Passagem'
    }
    if (templateId === 6) {
      return 'Orçamento de Viagem Internacional'
    }
    if (templateId === 7) {
      return 'Orçamento de Viagem Disney'
    }
  }
  const title = getTitle(templateId)
  usePageTitle(title)

  return (
    <PageHeaderPanel
      leftIcon="BsArrowLeftShort"
      leftAction={() => navigate(`/service-orders/${serviceOrder.id}/resume`)}
      title={title}
      mediumPadding
      noContainer
      side={<TemplateRecordPdfPrintButton name={title} recordId={serviceOrder.id} templateId={templateId} />}
    />
  )
}

export default PageHeader
